import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewResidentDialogComponent } from '../new-resident-dialog/new-resident-dialog.component';
import { ResidentSearchModel } from '@shared/models/data/resident-search-model';
import { ResidentSearchModelResponse } from '@shared/models/data/resident-search-model-response';

@Component({
    selector: 'aaos-app-resident-search-result-dialog',
    templateUrl: './resident-search-result-dialog.component.html',
    styleUrls: ['./resident-search-result-dialog.component.scss']
})
export class ResidentSearchResultDialogComponent implements OnInit {

    resident: ResidentSearchModel;
    newResident: ResidentSearchModel;

    @Output() actionTaken: EventEmitter<ResidentSearchModel> = new EventEmitter<ResidentSearchModel>();
    searchResultDisplayCity: string;

    constructor(public dialogRef: MatDialogRef<ResidentSearchResultDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ResidentSearchModelResponse,
        private dialog: MatDialog) { }

    ngOnInit() {
        this.newResident = new ResidentSearchModel();
    }

    addResident() {
        this.actionTaken.next(this.resident);
        this.dialogRef.close();
    }

    openAddNewResidentDiaog() {
        this.dialog.open(NewResidentDialogComponent, this.getModalConfig());
    }

    getModalConfig() {
        return {
            panelClass: 'wide-dialog',
            disableClose: true,
            autoFocus: false,
            data: this.resident,
        } as MatDialogConfig;
    }

    // Temporary formatting here. Maybe this should be done on backend and sent as a model property.
    formatCityState(item: ResidentSearchModel) {
        let returnValue = '';
        if (item.city) {
            returnValue = item.city;
        }
        if (item.state) {
            if (returnValue.length > 0) {
                returnValue += ', ';
            }
            returnValue += item.state;
        }
        return returnValue;
    }

}
